import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=2937a5aa"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"
import style0 from "./SingleProduct.vue?vue&type=style&index=0&id=2937a5aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports